import api from '@/utils/api'
const state = {
  subject: "",
  files: [],
  signersList: []
}
const mutations = {
  setFiles(state, payload) {   // 上传的文件
    state.files = payload
  },
  setSignersList(state, payload) {   // 签约数据
    state.signersList = payload
  },
  setSubject(state, payload) {   // 文件标题
    state.subject = payload
  },
}
const actions = {
  setFiles({ commit }, payload) {
    commit('setFiles', payload)
  },
  setSignersList({ commit }, payload) {
    commit('setSignersList', payload)
  },
  setSubject({ commit }, payload) {
    commit('setSubject', payload)
  },
  clearData({ commit }) {
    commit('setFiles', [])
    commit('setSignersList', [])
    commit('setSubject', '')
  },
  clearFiles({ commit }){
    commit('setFiles', [])
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations
}